// Shared number formatting helpers for presentational values (labels/cards/tables only).
// Uses de-DE locale to get dot thousand separators and comma decimals.
const integerFormatter = new Intl.NumberFormat("de-DE", { minimumFractionDigits: 0, maximumFractionDigits: 0 });
const decimal2Formatter = new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const decimal1Formatter = new Intl.NumberFormat("de-DE", { minimumFractionDigits: 1, maximumFractionDigits: 1 });

const isDash = (value) => value === "-";
const toNumber = (value) => {
    if (value === null || value === undefined || value === "") return NaN;
    const num = typeof value === "number" ? value : parseFloat(value);
    return Number.isNaN(num) ? NaN : num;
};

export function integerFormatting(x) {
    if (isDash(x)) return "-";
    const num = toNumber(x);
    if (Number.isNaN(num)) return "";
    return integerFormatter.format(num);
}

export function formatInteger(x) {
    return integerFormatting(x);
}

export function formatDecimal(x, fractionDigits = 2) {
    if (isDash(x)) return "-";
    const num = toNumber(x);
    if (Number.isNaN(num)) return "";
    if (fractionDigits === 1) return decimal1Formatter.format(num);
    return decimal2Formatter.format(num);
}

export function formatPercent(x) {
    if (isDash(x)) return "-";
    const num = toNumber(x);
    if (Number.isNaN(num)) return "";
    return `${decimal2Formatter.format(num)}%`;
}

export function formatCurrencyEUR(x, fractionDigits = 2) {
    if (isDash(x)) return "-";
    const num = toNumber(x);
    if (Number.isNaN(num)) return "€0,00";
    const formatter = new Intl.NumberFormat("de-DE", {
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
    });
    return `€${formatter.format(num)}`;
}